module.exports = __webpack_public_path__ + "static/img/tab1.0a6fc09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/tab1.jpg
// module id = zfx1
// module chunks = 1